<template>
<div style="height:100%">
  <div id="csContainer">
  </div>
  <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
                isShow: false,
                viewer: null
            }
        },
        mounted(){
           var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        methods:{
            init(){
                let viewer = new Cesium.Viewer("csContainer", {
                    imageryProvider : new Cesium.UrlTemplateImageryProvider({
                        url: "http://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}",

                    })
                });








            },

        }
    }
</script>
<style scoped>
  .headMap {
    position: absolute;
    margin-left: 20px;
    margin-top:10px;
    z-index: 999;
  }
  #heatmap{
    width: 500px;
    height: 500px;
  }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
